import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import DoorsTab from "../../../containers/doors-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import { Filter } from "../../../models/Filter";
import {  getListOfSiteIdsFromFilterWithKey } from "../../../utilities/tabUtils";
import {useTabCount} from "../../../hooks/useCategoryTab";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const Doors: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));

    const { updateTabCount } = useTabCount({
        tableName: "Location",
        pathToSite: "zoneByZoneId.controller.site",
        categories,
        setCategories
    });

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.doors),
                    heading: translate.byKey(TranslationKeys.doors),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        buildCategoriesData();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <DoorsTab setBusy={setBusy} categories={categories} onFilterChange={onFilterChange} setCategories={setCategories}/>
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilterWithKey(filters, "zoneByZoneId.controller.deviceImprox.site.id");
        updateTabCount(siteIds);
    };

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/hardware",
                                displayName: translate.byKey(TranslationKeys.hardware),
                            },
                            {
                                value: "/access-control/hardware/doors",
                                displayName: translate.byKey(TranslationKeys.doors),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row justify-end button-cluster">
                                <Restricted to={`add.${routeName}.element`}>
                                    <Link
                                        to={{
                                            pathname: "/access-control/hardware/door/",
                                        }}>
                                        <Button variant="submit" shape="rounded" id="doorsAddButtonId">
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt="" />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </Button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default Doors;
